import { MinusCircleOutlined } from '@ant-design/icons';
import { AutoComplete, Button, Col, Divider, Form, Input, Row } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  addUserAdministrationCompanies,
  removeUserAdministrationCompanies,
  updateUserAdministrationCompanies,
} from '../../../../../contextRedux/User/UserModel';
import { RootState } from '../../../../../store';
import './UserCompanyTab.css';

const UserCompanyTab: React.FC = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const id = useSelector((state: RootState) => state?.models?.user?.id) ?? '';
  const userAdministrationCompanies = useSelector(
    (state: RootState) => state.store.userAdministrationCompany.data || []
  );
  const initialValues = useSelector((state: RootState) => state.models.user.userAdministrationCompanies || []);

  useEffect(() => {
    form.setFieldsValue({ userAdministrationCompanies: initialValues });
  }, [initialValues, form]);

  const handleAddCompany = (addFn: any) => {
    const newCompany = {
      id: null,
      userId: id,
      administrationCompanyId: null,
      name: '',
      administrationCompany: { id: null, name: '' },
      norm: '',
      internalFunction: '',
      dateOfEmployment: '',
      dateOfCim: '',
      cor: '',
      nameCor: '',
    };

    // Add to the form list first, then update Redux
    addFn(newCompany);
    dispatch(addUserAdministrationCompanies(newCompany));
  };

  const handleRemoveCompany = (index: number, removeFn: any) => {
    removeFn(index);
    dispatch(removeUserAdministrationCompanies(index));
  };

  const handleSelectAdministrationCompany = (value: string, index: number) => {
    const selectedCompany = userAdministrationCompanies.find((company) => company.name === value);

    if (selectedCompany) {
      const updates = {
        administrationCompanyId: selectedCompany.id,
        name: selectedCompany.name,
        administrationCompany: { id: selectedCompany.id, name: selectedCompany.name },
      };

      dispatch(updateUserAdministrationCompanies({ index, updates }));

      const currentCompanies = form.getFieldValue('userAdministrationCompanies') || [];
      currentCompanies[index] = { ...currentCompanies[index], ...updates };
      form.setFieldsValue({ userAdministrationCompanies: currentCompanies });
    }
  };

  const handleValuesChange = (changedValues: any, _allValues: any) => {
    const changedCompanies = changedValues.userAdministrationCompanies;
    if (changedCompanies) {
      changedCompanies.forEach((changedCompany: any, index: number) => {
        if (changedCompany) {
          dispatch(updateUserAdministrationCompanies({ index, updates: changedCompany }));
        }
      });
    }
  };

  return (
    <Form
      form={form}
      name='userCompanyForm'
      initialValues={{ userAdministrationCompanies: initialValues }}
      onValuesChange={handleValuesChange}
      layout='vertical'
      className='userCompanyTab'
    >
      <Form.List name='userAdministrationCompanies'>
        {(fields, { add, remove }) => (
          <>
            {fields.map((field, index) => (
              <Row key={field.key} gutter={[16, 16]} align='middle' style={{ marginBottom: '20px' }}>
                <Col xs={24}>
                  <Form.Item
                    {...field}
                    label='Selectează Companie'
                    name={[field.name, 'administrationCompany', 'name']}
                    rules={[{ required: true, message: 'Selectează o companie!' }]}
                  >
                    <AutoComplete
                      options={userAdministrationCompanies.map((company) => ({ value: company.name }))}
                      onSelect={(value) => handleSelectAdministrationCompany(value, index)}
                      placeholder='Alege o Companie'
                      style={{ width: '100%' }}
                      filterOption={(inputValue, option) =>
                        option?.value.toLowerCase().includes(inputValue.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item label='Norm' name={[field.name, 'norm']}>
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item label='Funcție Internă' name={[field.name, 'internalFunction']}>
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label='Data Angajării'
                    name={[field.name, 'dateOfEmployment']}
                    rules={[{ required: true, message: 'Introduceti data angajării!' }]}
                  >
                    <Input type='date' />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label='Data CIM'
                    name={[field.name, 'dateOfCim']}
                    rules={[{ required: true, message: 'Introduceti data CIM!' }]}
                  >
                    <Input type='date' />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item label='Cor' name={[field.name, 'cor']}>
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item label='Nume Cor' name={[field.name, 'nameCor']}>
                    <Input />
                  </Form.Item>
                </Col>
                <Col xl={4}>
                  <Button
                    type='link'
                    icon={<MinusCircleOutlined />}
                    onClick={() => handleRemoveCompany(field.name, remove)}
                  />
                </Col>
                <Divider />
              </Row>
            ))}
            <Form.Item>
              <Button type='dashed' onClick={() => handleAddCompany(add)} style={{ width: '100%' }}>
                Adaugă o Companie
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form>
  );
};

export default UserCompanyTab;
